import { StringParam } from 'use-query-params';

export const queryParams = {
  gameId: StringParam,
};
